import { FC, ReactNode } from 'react';
import LottiePlayer from 'lottie-react';

import styles from './styles.module.scss';
import Cloud1 from '../../../../assets/animations/metro/cloud-1.json';
import Cloud2 from '../../../../assets/animations/metro/cloud-2.json';
import Cloud3 from '../../../../assets/animations/metro/cloud-3.json';
import Cloud4 from '../../../../assets/animations/metro/cloud-4.json';
import Cloud5 from '../../../../assets/animations/metro/cloud-5.json';
import Cloud6 from '../../../../assets/animations/metro/cloud-6.json';
import Cloud7 from '../../../../assets/animations/metro/cloud-6.json';
import Auto1 from '../../../../assets/animations/metro/auto.json';
import Auto2 from '../../../../assets/animations/metro/auto-2.json';
import Auto3 from '../../../../assets/animations/metro/auto-3.json';
import LeftHouse from '../../../../assets/images/metro/difficulty/LeftHouse.svg';
import RightHouse from '../../../../assets/images/metro/difficulty/RightHouse.svg';
import LeftHouseTablet from '../../../../assets/images/metro/difficulty/LeftHouseTablet.svg';
import RightHouseTablet from '../../../../assets/images/metro/difficulty/RightHouseTablet.svg';
import Trees from '../../../../assets/images/metro/difficulty/Trees.svg';

type TStatusBackgroundLayoutProps = {
  children: ReactNode;
  contentClassName?: string;
};

const StatusBackgroundLayout: FC<TStatusBackgroundLayoutProps> = ({ children, contentClassName }) => {
  return (
    <div className={styles.statusLayout}>
      <div className={styles.upperBg}>
        <div className={styles.autoWrapper}>
          <LottiePlayer className={styles.auto3} animationData={Auto3} autoPlay loop />
          <LottiePlayer className={styles.auto} animationData={Auto1} autoPlay loop />
          <LottiePlayer className={styles.auto2} animationData={Auto2} autoPlay loop />
        </div>

        <LottiePlayer className={styles.cloud1} animationData={Cloud1} autoPlay loop />
        <LottiePlayer className={styles.cloud2} animationData={Cloud2} autoPlay loop />
        <LottiePlayer className={styles.cloud3} animationData={Cloud3} autoPlay loop />
        <LottiePlayer className={styles.cloud4} animationData={Cloud4} autoPlay loop />
        <LottiePlayer className={styles.cloud5} animationData={Cloud5} autoPlay loop />
        <LottiePlayer className={styles.cloud6} animationData={Cloud6} autoPlay loop />
        <LottiePlayer className={styles.cloud7} animationData={Cloud7} autoPlay loop />
        <img alt="" src={Trees} className={styles.trees1} />
        <img alt="" src={Trees} className={styles.trees2} />
        <img alt="" src={LeftHouseTablet} className={styles.leftHouseTablet} />
        <img alt="" src={RightHouseTablet} className={styles.rightHouseTablet} />
        <img alt="" src={LeftHouse} className={styles.leftHouse} />
        <img alt="" src={RightHouse} className={styles.rightHouse} />
        <div className={contentClassName}>{children}</div>
      </div>

      <div className={styles.bottomBg} />
    </div>
  );
};

export default StatusBackgroundLayout;
